import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import debounce from '~/utilities/debounce.js';
var emptyState = {
  id: null,
  perfomers: [],
  clients: [],
  profiles: [],
  title: "",
  headerType: 'default',
  headerImage: null,
  headerColor: null,
  description: '',
  showDescription: false,
  syncTitle: true,
  metaTitle: '',
  metaDescription: '',
  thumbnail: {
    name: null
  },
  isGeneratedThumbnail: false,
  specialization: null,
  tags: [],
  status: 'draft',
  modules: [],
  isTemp: false,
  original: null,
  slug: '',
  locale: '',
  ogGradient: null,
  defaultMediaTemplate: 'default',
  allowDofollowLinks: false
};
export var usePublicationEditorStore = defineStore({
  id: 'publicationEditor',
  state: function state() {
    return {
      post: {},
      saving: false,
      fieldsToSave: [],
      autosaveEnabled: false,
      canPublish: false,
      dofollowTokens: 0,
      uploading: false,
      uploadImageModule: {
        type: 'UploadImageModule',
        index: -1,
        id: 'image-uploader',
        isSystemModule: true
      },
      validations: {}
    };
  },
  getters: {
    canEdit: function canEdit(state) {
      if (this.$nuxt.$auth.user.user && this.$nuxt.$auth.user.role.fullAccess) return true;
      return ['draft', 'denied'].includes(state.post.status);
    },
    status: function status(state) {
      return state.post.status;
    }
  },
  actions: {
    init: function init(data) {
      this.post = JSON.parse(JSON.stringify(emptyState));
      this.post = Object.assign(this.post, data.post);
      this.dofollowTokens = data.dofollowTokens;
      this.validations = data.validations;
      this.canPublish = data.canPublish;
    },
    updateField: function updateField(_ref) {
      var field = _ref.field,
        value = _ref.value;
      this.post[field] = value;
    },
    setOwner: function setOwner(index) {
      var oldIndex = this.post.perfomers.findIndex(function (o) {
        return o.isOwner;
      });
      this.post.perfomers[oldIndex].isOwner = false;
      this.post.perfomers[index].isOwner = true;
    },
    updateTeamProfile: function updateTeamProfile(_ref2) {
      var teamType = _ref2.teamType,
        teamIndex = _ref2.teamIndex,
        field = _ref2.field,
        value = _ref2.value,
        profileIndex = _ref2.profileIndex;
      if (typeof profileIndex !== 'undefined') {
        this.post[teamType][teamIndex].team[profileIndex][field] = value;
      } else {
        this.post[teamType][teamIndex].profile[field] = value;
      }
    },
    updateTeam: function updateTeam(_ref3) {
      var teamType = _ref3.teamType,
        teamIndex = _ref3.teamIndex,
        field = _ref3.field,
        value = _ref3.value;
      this.post[teamType][teamIndex][field] = value;
    },
    saveField: function saveField(field) {
      if (!this.fieldsToSave.includes(field)) {
        this.fieldsToSave.push(field);
      }
    },
    //-------
    // Module mutations
    //-------
    addModule: function addModule(_ref4) {
      var module = _ref4.module,
        index = _ref4.index;
      // Check for duplicate
      if (!this.post.modules.some(function (o) {
        return o.id == module.id;
      })) {
        this.post.modules.splice(index, 0, module);
      }
    },
    updateModule: function updateModule(_ref5) {
      var module = _ref5.module,
        index = _ref5.index;
      if (!module) return;
      var foundIndex = this.post.modules.findIndex(function (o) {
        return o.id == module.id;
      });

      // Update
      if (foundIndex >= 0) {
        this.post.modules.splice(foundIndex, 1, module);
        // Create
      } else {
        if (typeof index == 'undefined') index = this.post.modules.length;
        this.post.modules.splice(index, 0, module);
      }
    },
    // Update non post mutations
    setState: function setState(update) {
      for (var key in update) {
        this[key] = update[key];
      }
    },
    setImageUploaderIndex: function setImageUploaderIndex(index) {
      // If upload module is shown and its new index is bigger than current
      // New index has to be reduced by one
      // Coz it will be revoved from prev index
      if (this.uploadImageModule.index >= 0 && index > this.uploadImageModule.index) index = index - 1;
      this.uploadImageModule.index = index;
    },
    clear: function clear() {
      this.post = JSON.parse(JSON.stringify(emptyState));
    },
    // Teams 
    updateProfiles: function updateProfiles() {
      var profiles = [];
      this.post.perfomers.forEach(function (perfomer) {
        if (perfomer.profile.id) profiles.push(perfomer.profile.id);
        if (perfomer.team) {
          perfomer.team.forEach(function (profile) {
            if (profile.id) profiles.push(profile.id);
          });
        }
      });
      this.post.clients.forEach(function (client) {
        if (client.profile.id) profiles.push(client.profile.id);
        if (client.team) {
          client.team.forEach(function (profile) {
            if (profile.id) profiles.push(profile.id);
          });
        }
      });
      this.post.profiles = profiles;
    },
    addTeam: function addTeam(_ref6) {
      var type = _ref6.type,
        value = _ref6.value;
      this.post[type].push(value);
      this.updateProfiles();
    },
    removeTeam: function removeTeam(_ref7) {
      var teamType = _ref7.teamType,
        index = _ref7.index;
      this.post[teamType].splice(index, 1);
      this.updateProfiles();
    },
    addUser: function addUser(_ref8) {
      var type = _ref8.type,
        profile = _ref8.profile,
        index = _ref8.index;
      this.post[type][index].team.push(profile);
      this.updateProfiles();
    },
    removeUser: function removeUser(_ref9) {
      var teamType = _ref9.teamType,
        teamIndex = _ref9.teamIndex,
        index = _ref9.index;
      this.post[teamType][teamIndex].team.splice(index, 1);
      this.updateProfiles();
    },
    updateTitle: function updateTitle() {
      if (this.post.syncTitle) this.savePost({
        metaTitle: this.post.title
      });
    },
    // Action to update post fields and save it on server
    savePost: function savePost(update) {
      for (var field in update) {
        this.updateField({
          field: field,
          value: update[field]
        });
        if (this.autosaveEnabled) this.saveField(field);
      }

      // Some updates has to be applied immediatly
      if (update.type) {
        this.save();
      } else if (this.autosaveEnabled) {
        this.debounceSave(this, {
          name: 'save',
          payload: update
        });
        this.saving = true;
      }
    },
    // Action to update post fields
    updatePost: function updatePost(update) {
      for (var field in update) {
        this.updateField({
          field: field,
          value: update[field]
        });
      }
    },
    debounceSave: debounce(function (store, _ref10) {
      var name = _ref10.name,
        payload = _ref10.payload;
      store[name](payload);
    }, 700),
    // Socket request
    save: function save() {
      var _this = this;
      this.saving = true;
      var update = {
        id: this.post.id,
        _csrf: useAppStore().csrfToken
      };
      this.fieldsToSave.forEach(function (key) {
        update[key] = _this.post[key];
      });
      this.$nuxt.$socket.post('/publication/update', update, function (resData, jwres) {
        _this.saving = false;

        // For changeng type its better to update whole page 
        if (update.type && process.client) {
          window.location.reload();
        }
        if (jwres.statusCode !== 200) {
          // this.savingError = true;

          // let toast = {
          //     title: 'Невдалось оновити',
          //     text: '',
          //     icon: 'icon-ic-dismiss'
          // }

          if (jwres && jwres.body) toast.text = jwres.body;
          // this.$toastStore.add(toast);
          console.error(jwres.error);
        }
        _this.fieldsToSave = [];
      });
    },
    mergeText: function mergeText(index) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var topModule, nextModule, textType, update;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              topModule = _this2.post.modules[index];
              nextModule = _this2.post.modules[index + 1];
              textType = "text-module";
              if (!(!topModule || !nextModule || topModule.type != textType || nextModule.type != textType)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              update = {
                module: {
                  type: textType,
                  html: topModule.html + nextModule.html,
                  id: topModule.id
                },
                index: index,
                refresh: true
              };
              _context.next = 8;
              return _this2.sendModule(update);
            case 8:
              _this2.deleteServerModule(nextModule.id);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    deleteLocaleModule: function deleteLocaleModule(payload) {
      var index = this.post.modules.findIndex(function (o) {
        return o.id == payload.id;
      });
      if (index >= 0) this.post.modules.splice(index, 1);
    },
    deleteServerModule: function deleteServerModule(id) {
      var _this3 = this;
      this.saving = true;
      var params = {
        id: this.post.id,
        module: id,
        _csrf: useAppStore().csrfToken
      };
      this.$nuxt.$socket.post('/publication/deleteModule', params, function (resData, jwres) {
        _this3.saving = false;
        if (jwres.statusCode !== 200) {

          // let toast = {
          //     title: 'Невдалось видалити',
          //     text: '',
          //     icon: 'icon-ic-dismiss'
          // }

          // if (jwres && jwres.body) toast.text = jwres.body;
          // this.$toastStore.add(toast);
          // return console.error(jwres.error)
        }
      });
      this.deleteLocaleModule({
        id: id
      });
    },
    swapModules: function swapModules(_ref11) {
      var _this4 = this;
      var a = _ref11.a,
        b = _ref11.b;
      this.post.modules[a] = this.post.modules.splice(b, 1, this.post.modules[a])[0];
      setTimeout(function () {
        _this4.savePost({
          modules: _this4.post.modules
        });
      }, 10);
    },
    reorderModules: function reorderModules(modules) {
      this.post.modules = modules;
      this.savePost({
        modules: modules
      });
    },
    saveModule: function saveModule(payload) {
      this.updateModule(payload);
      if (this.autosaveEnabled) {
        this.debounceSave(this, {
          name: 'sendModule',
          payload: payload
        });
        this.saving = true;
      }
    },
    /**
     *
     * @param {*} param0
     * @param {Boolean} refresh If true will resive updated module by socket - it will trigger scket update event
     * @returns
     */
    sendModule: function sendModule(_ref12) {
      var _this5 = this;
      var index = _ref12.index,
        module = _ref12.module,
        refresh = _ref12.refresh;
      return new Promise(function (resolve, reject) {
        _this5.saving = true;
        var update = {
          module: module,
          index: index,
          id: _this5.post.id,
          _csrf: useAppStore().csrfToken,
          refresh: refresh
        };
        _this5.$nuxt.$socket.post('/publication/createOrUpdateModule', update, function (resData, jwres) {
          _this5.saving = false;
          resolve();
          if (jwres.statusCode !== 200) {
            // this.savingError = true;

            // let toast = {
            //     title: 'Невдалось оновити',
            //     text: '',
            //     icon: 'icon-ic-dismiss'
            // }

            // if (jwres && jwres.body) toast.text = jwres.body;
            // this.$toastStore.add(toast);
            // return console.error(jwres.error)
          }
        });
      });
    },
    uploadImages: function uploadImages(images) {
      var _this6 = this;
      var _URL = window.URL || window.webkitURL;
      var startIndex = new Number(this.uploadImageModule.index); // Cache value

      var _newId = function newId() {
        var increment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var id = new Date().getTime() + increment;
        if (_this6.post.modules.some(function (o) {
          return o.id == id;
        })) {
          return _newId(increment + 1);
        }
        return id;
      };
      var _initImage = function initImage(i) {
        var context = _this6;
        var index = startIndex + i;
        var file = images[i];
        var maxSize = 10000000; //10MB (10*1000*1000)
        var maxProportion = 0.25; // 1:4

        if (!file) return;
        if (file.size > maxSize) {
          _this6.$nuxt.$toastStore.add({
            title: _this6.$nuxt.i18n.t("editor.validation.imageSizeTitle", {
              name: file.name
            }),
            text: _this6.$nuxt.i18n.t("editor.validation.imageSizeText"),
            icon: 'icon-ic-dismiss',
            autoClose: false
          });
          return _initImage(i + 1);
        }
        var module = {
          file: file,
          id: _newId(i),
          type: 'ImageModule',
          progress: 0,
          index: index,
          uploading: true,
          caption: '',
          showCaption: false,
          image: {},
          view: _this6.post.defaultMediaTemplate || 'default'
        };
        var image = new Image();
        image.onload = function () {
          module.image.width = this.width;
          module.image.height = this.height;
          if (image.width / image.height < maxProportion) {
            this.$nuxt.$toastStore.add({
              title: context.$nuxt.i18n.t("editor.validation.imageHeightTitle", {
                name: file.name
              }),
              text: context.$nuxt.i18n.t("editor.validation.imageHeightText"),
              icon: 'icon-ic-dismiss',
              autoClose: false
            });
            return _initImage(i + 1);
          }
          context.addModule({
            index: index,
            module: module
          });
          context.upload();
          _initImage(i + 1);
        };
        image.src = _URL.createObjectURL(file);
      };

      // Load and then add images one-by-one
      _initImage(0);
      this.setImageUploaderIndex(-1);
    },
    upload: function upload() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var index, module, formData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              index = _this7.post.modules.findIndex(function (o) {
                return o.uploading;
              });
              module = _this7.post.modules[index];
              if (!(!module || _this7.uploading)) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              _this7.uploading = true;
              formData = new FormData();
              formData.append('index', index);
              formData.append('id', _this7.post.id);
              formData.append('moduleid', module.id);
              formData.append('file', module.file);
              _context2.next = 12;
              return _this7.$nuxt.$axios.$post('/publication/upload', formData, {
                onUploadProgress: function onUploadProgress(uploadEvent) {
                  _this7.post.modules[index].progress = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
                }
              }).then(function (serverModule) {
                _this7.uploading = false;
                _this7.updateModule({
                  module: serverModule,
                  index: index
                });
                setTimeout(function () {
                  _this7.upload();
                }, 100);
              }).catch(function (error) {
                _this7.deleteServerModule(module.id);
                console.log(error);

                // let res = error.response ? error.response.data : null;
                // let toast = {
                //     title: this.$t('page.module.practice.toast.error'),
                //     text: this.$t('page.module.practice.upload.toast.cantUpload'),
                //     icon: 'icon-ic-dismiss'
                // }

                // if (res && res.message) toast.text = res.message;
                // this.$toastStore.add(toast);
              });
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    validate: function validate() {
      var _this8 = this;
      var rules = {
        notEmpty: function notEmpty(val) {
          return val.length;
        },
        required: function required(val) {
          return !!val;
        },
        hasName: function hasName(val) {
          return val && !!val.name;
        }
      };
      var failedFields = [];
      var _loop = function _loop() {
        var _iterator = _createForOfIteratorHelper(_this8.validations[field]),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var rule = _step.value;
            if (rules[rule] && !rules[rule](_this8.post[field])) {
              failedFields.push(field);
            }
          }

          // Check if all modules are empty
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (field == 'modules' && _this8.post.modules) {
          var emptyLength = 0;
          _this8.post.modules.forEach(function (module) {
            var emptyHtml = ['', '<p></p>', '<p><br></p>'];
            if (module.type == 'embed-module' && !module.embed) emptyLength++;
            if (module.type == 'image-module' && !module.src) emptyLength++;
            if (module.type == 'text-module' && emptyHtml.includes(module.html)) {
              emptyLength++;
            }
          });
          if (emptyLength == _this8.post.modules.length && !failedFields.includes(field)) {
            failedFields.push(field);
          }
        }
      };
      for (var field in this.validations) {
        _loop();
      }
      return failedFields;
    },
    submit: function submit() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var error, failedFields, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              error = null;
              if (_this9.canEdit) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              _context3.next = 5;
              return _this9.validate();
            case 5:
              failedFields = _context3.sent;
              if (!failedFields.length) {
                _context3.next = 8;
                break;
              }
              return _context3.abrupt("return", failedFields);
            case 8:
              _context3.next = 10;
              return _this9.$nuxt.$axios.$post('/publication/publish', {
                id: _this9.post.id
              }).catch(function (err) {
                return error = err;
              });
            case 10:
              res = _context3.sent;
              if (!error) {
                _context3.next = 13;
                break;
              }
              throw new Error(error);
            case 13:
              _this9.updateField({
                field: 'status',
                value: res.status
              });
              _this9.updateField({
                field: 'slug',
                value: res.slug
              });
              return _context3.abrupt("return", res);
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    unsubmit: function unsubmit() {
      var _this10 = this;
      this.saving = true;
      if (this.post.status !== 'pending') return;
      var payload = {
        id: this.post.id,
        _csrf: useAppStore().csrfToken
      };
      this.$nuxt.$socket.post('/publication/draft', payload, function (resData, jwres) {
        _this10.saving = false;
        if (jwres.statusCode !== 200) {
          console.log(jwres);
          // this.savingError = true;

          // let toast = {
          //     title: 'Невдалось оновити',
          //     text: '',
          //     icon: 'icon-ic-dismiss'
          // }

          // if (jwres && jwres.body) toast.text = jwres.body;
          // this.$toastStore.add(toast);
          // return console.error(jwres.error)

          return false;
        } else {
          _this10.updateField({
            field: 'status',
            value: 'draft'
          });
          return true;
        }
      });
    }
  }
});